import Vue from 'vue'
import { Icon } from 'vant'
import Router from 'vue-router'
import top from '@/views/Top'
import home from '@/views/Home'
import searchProjectors from '@/views/SearchProjectors'
import lensList from '@/views/LensList'
import categolies from '@/views/Categolies'
import projectorInfo from '@/views/ProjectorInfo'
import projectorView from '@/views/ProjectorView'
import nearModel from '@/views/NearModel'
import notes from '@/views/Notes'
import specification from '@/views/specification'
import tbd from '@/views/tbd'

Vue.use(Router)
Vue.use(Icon)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'top',
      component: top
    }, {
      path: '/home',
      name: 'home',
      component: home
    }, {
      path: '/searchProjectors',
      name: 'searchProjectors',
      component: searchProjectors
    }, {
      path: '/lensList',
      name: 'lensList',
      component: lensList
    }, {
      path: '/categolies',
      name: 'categolies',
      component: categolies
    }, {
      path: '/projectorInfo',
      name: 'projectorInfo',
      component: projectorInfo
    }, {
      path: '/projectorView',
      name: 'projectorView',
      component: projectorView
    }, {
      path: '/nearModel',
      name: 'nearModel',
      component: nearModel
    },
    {
      path: '/notes',
      name: 'notes',
      component: notes
    }, {
      path: '/specification',
      name: 'Specification',
      component: specification
    }, {
      path: '/tbd',
      name: 'Tbd',
      component: tbd
    }]
})
